import React from 'react';

const { useState, useEffect } = React;

function useMediaQuery(query) {
	const getMatches = (matchQuery) => {
		// Prevents SSR issues
		if (typeof window !== 'undefined' && window.matchMedia) {
			return window.matchMedia(matchQuery).matches;
		}

		return false;
	};

	const [matches, setMatches] = useState(getMatches(query));

	function handleChange() {
		setMatches(getMatches(query));
	}

	useEffect(() => {
		const matchMedia = window.matchMedia(query);

		// Triggered at the first client-side load and if query changes
		handleChange();

		// Listen matchMedia
		if (matchMedia.addListener) {
			matchMedia.addListener(handleChange);
		} else {
			matchMedia.addEventListener('change', handleChange);
		}

		return () => {
			if (matchMedia.removeListener) {
				matchMedia.removeListener(handleChange);
			} else {
				matchMedia.removeEventListener('change', handleChange);
			}
		};
	}, [query]);

	return matches;
}

export default useMediaQuery;
